"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setReferralInfo = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
const setReferralInfo = (tenant, voucherName) => {
  if (!voucherName || !tenant) {
    return;
  }
  const topArea = document.getElementById('online-top-area-root');
  const config = topArea?.getAttribute('data-config') ?? '';
  let isInternationalShareAndEarn = false;
  if (config) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- x
    isInternationalShareAndEarn = JSON.parse(config).useInternationalShareAndEarn ?? false;
  }
  let referral = '';
  if (voucherName.charAt(2) === '-' || !isInternationalShareAndEarn) {
    referral = voucherName;
  } else {
    referral = `${tenant.toUpperCase()}-${voucherName}`;
  }
  _jsCookie.default.set(_presentationUtils.PbsCookieNames.PBS_OWNER, referral);
  (0, _presentationUtils.ensureQueryParameter)('store', referral);
};
exports.setReferralInfo = setReferralInfo;
